import { HttpRequest, HttpMethod } from "./http";

// Storefront collections + the Discovery Sets singleton — BO admin CRUD on the
// App PG (spec docs/specs/2026-10-13-www-nav-i18n-collections-design.md §3.3).
// Envelope {data: …}. Errors: 400 {code, errors:[{field, rule}]}
// (invalid_body | slug_reserved | too_many_items), 409 slug_taken / stale,
// 503 schema_missing (SQL not run yet), 403 access_denied for non-admin writes
// (401 only for an invalid / expired token).
// `unavailable:{products:[],bundles:[]}` lives inside `data` on the detail GETs.
const BASE = "/api/v1/bo/storefront/collections";
const DISCOVERY = "/api/v1/bo/storefront/discovery-sets";

class StorefrontCollectionProvider extends HttpRequest {
    // {data:[{id,slug,name_th,name_en,cover_url,item_count,is_active,sort_order,updated_at,updated_by}]}
    list() {
        return this.request(HttpMethod.Get, BASE);
    }

    get(id) {
        return this.request(HttpMethod.Get, `${BASE}/${id}`);
    }

    // {slug,name_th,name_en,description_th,description_en,cover_key,items,is_active}
    create(payload) {
        return this.request(HttpMethod.Post, BASE, payload);
    }

    // Same body + expected_updated_at. Omitting `items` keeps the stored list.
    update(id, payload) {
        return this.request(HttpMethod.Put, `${BASE}/${id}`, payload);
    }

    remove(id) {
        return this.request(HttpMethod.Delete, `${BASE}/${id}`);
    }

    // {ids:[…]} → sort_order = index. Returns the list in the new order.
    reorder(ids) {
        return this.request(HttpMethod.Post, `${BASE}/reorder`, { ids });
    }

    // {data: row + unavailable} or {data: null} before the first save.
    getDiscovery() {
        return this.request(HttpMethod.Get, DISCOVERY);
    }

    // Upsert {name_th,name_en,description_th,description_en,cover_key,items,is_active}.
    saveDiscovery(payload) {
        return this.request(HttpMethod.Put, DISCOVERY, payload);
    }
}

export default StorefrontCollectionProvider;
